<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/luK1tV/tc-custom/9780547525181.jpg?1726454431926" alt="This image is the cover for the book Happy Isles of Oceania"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Happy Isles of Oceania
      </h1>
      <p class="bookDescription body article font2">
        <b>The author of <i>The Great Railway Bazaar</i> explores the South Pacific by kayak: “This exhilarating epic ranks with [his] best travel books” (<i>Publishers Weekly</i>).</b><br/>  <br/> In one of his most exotic and adventuresome journeys, travel writer Paul Theroux embarks on an eighteen-month tour of the South Pacific, exploring fifty-one islands by collapsible kayak. Beginning in New Zealand's rain forests and ultimately coming to shore thousands of miles away in Hawaii, Theroux paddles alone over isolated atolls, through dirty harbors and shark-filled waters, and along treacherous coastlines.<br/>  <br/> Along the way, Theroux meets the king of Tonga, encounters street gangs in Auckland, and investigates a cargo cult in Vanuatu. From Australia to Tahiti, Fiji, Easter Island, and beyond, this exhilarating tropical epic is full of disarming observations and high adventure.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Paul Theroux
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (hmhbooks.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e1602384